import { EasComponentsSettings } from "@cirrus/legacy/app-components/entries/lib.js"
var UserActions = require("@cirrus/legacy/app-common/stores/current-user/actions")
var CustomerInfo = require("@cirrus/legacy/app-common/customer-info.js").default

require("./handlebars/url-helpers.es6")

import jss from "jss"
import preset from "jss-preset-default"
import { setVariables } from "@cirrus/legacy/app-common/alt/framework/skin/skinUtils.es6"
import { saveRegionalFormatsToStorage } from "@cirrus/legacy/features/core/shared/utils/sessionStorage.es6"

var _handleSettings = () => {}
var _beforeStart = () => {}
var _setSpellchecker = () => {}
var _setReadspeaker = () => {}
var _onStart = () => {}
var _afterStart = () => {}
var _onAjaxError = (ajaxError, readyState) => {
  if (readyState.status == 401) {
    document.location.replace("/")
  }
}

function loadSettings() {
  return new Promise((resolve, reject) => {
    $.ajax({
      url: App.isAnonymous
        ? Url.api("/api/v1/delivery/anonymous/user/settings")
        : Url.api("/api/v1/user/settings"),
      success: resolve,
      error: reject,
    })
  })
}

function handleSettings(response) {
  return new Promise((resolve, reject) => {
    UserActions.load(response)

    if (App.isPreview && App.previewLang) {
      response.regs.lang = App.previewLang
      sessionStorage.setItem("loginLang", App.previewLang)
    }

    App.regionalSettings = response.regs
    saveRegionalFormatsToStorage(App.regionalSettings.formats)

    App.features = response.features
    App.settings = response.settings
    App.settings.defaultAvatar = "../../static/img/default-avatar.png"
    App.settings.isDebugMode = CustomerInfo.get("isDebugMode")

    const handleSettingsCompleted = _handleSettings()

    var global = require("@cirrus/legacy/app-common/framework/globalization/time")
    global.setMomentLocal()

    var text = require("@cirrus/legacy/app-common/utils/text")
    App.Text = text.createTranslator(App.lang)
    EasComponentsSettings.translationFunction = App.Text.get2.bind(App.Text)

    handleSettingsCompleted.then(() => resolve())
  })
}

function beforeStart() {
  return new Promise((resolve, reject) => {
    _beforeStart()
    resolve()
  })
}

function setSpellchecker() {
  return new Promise((resolve, reject) => {
    _setSpellchecker()
    resolve()
  })
}
function setReadspeaker() {
  const id = CustomerInfo.get("readSpeakerCustomerId")
  const region = CustomerInfo.get("readSpeakerRegion")
  return new Promise((resolve, reject) => {
    _setReadspeaker(id, region)
    resolve()
  })
}

function appStart() {
  return new Promise((resolve, reject) => {
    _onStart()
    App.on("start", () => {
      resolve()
    })

    App.mount.then(() => {
      App.start({})
    })
  })
}

function afterStart() {
  require("./afterStartCommon")()
  _afterStart()
}

function loadSkin() {
  return new Promise((resolve, reject) => {
    jss.setup(preset())
    let skinValue = CustomerInfo.get("skinValue")
    let skinObject = JSON.parse(skinValue || "{}")
    App.skinObject = setVariables(skinObject.vars, skinObject)

    var skin = CustomerInfo.get("skin") ? CustomerInfo.get("skin") : null

    if (!skin) {
      document.body.classList.add("default-background")
      resolve()
      return
    }

    var xhr = new XMLHttpRequest()
    try {
      xhr.open("GET", skin)
      xhr.onreadystatechange = () => {
        if (xhr.status == 200) {
          $("head").append("<style>" + xhr.responseText + "</style>")
        }
        resolve()
      }
      xhr.send()
    } catch (e) {
      resolve()
    }
  })
}

$(document).ajaxError((ajaxError, readyState) => _onAjaxError(ajaxError, readyState))

App.Started = new Promise(function (resolve, reject) {
  App.on("start", () => {
    resolve()
  })
})

export default function (options) {
  if (options.setReadspeaker) {
    _setReadspeaker = options.setReadspeaker
  }
  _handleSettings = options.handleSettings
  _beforeStart = options.beforeStart
  _onStart = options.onStart
  if (options.setSpellchecker) {
    _setSpellchecker = options.setSpellchecker
  }

  if (typeof options.afterStart != "undefined") {
    _afterStart = options.afterStart
  }

  if (typeof options.onAjaxError != "undefined") {
    _onAjaxError = options.onAjaxError
  }

  const runStart = () => {
    beforeStart()
      .then(loadSkin)
      .then(loadSettings)
      .then(handleSettings)
      .then(setReadspeaker)
      .then(setSpellchecker)
      .then(appStart)
      .then(afterStart)
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", runStart)
  } else {
    runStart();
  }

  var func = Marionette.Module.create
  Marionette.Module.create = function (app, moduleNames, moduleDefinition) {
    var module = func.apply(this, arguments)
    module.fullName = moduleNames
    return module
  }
}
